import React from "react";
import RecognitionActionCard from "components/NewCards/RecognitionActionCard";

interface Recognition {
    RECOGNITION_IMAGE?: { selectedImage: string };
    RECOGNITION_ACHIEVEMENT?: string;
    RECOGNITION_ISSUED_BY?: string;
    RECOGNITION_YEAR?: string;
    RECOGNITION_DESCRIPTION?: string;
    // Add other properties of your recognition object if needed
}

const RecognitionsPreview = () => {
    const recognitionsData: Recognition[] = JSON.parse(sessionStorage.getItem("recognitions")) || [];

    if (!recognitionsData || recognitionsData.length === 0) {
        return <p className="text-gray-500">No recognitions added yet.</p>;
    }

    return (
        <div className="grid grid-cols-4 gap-4 sm:grid-cols-1 md:grid-cols-1">
            {recognitionsData.map((recognition, index) => (
                <RecognitionActionCard
                    key={`recognition-preview-${index}`}
                    element={recognition}
                    // handleOpenDrawer={() => {}} // No operation in preview
                    // onDelete={() => {}} // No operation in preview
                    isError={false} // Default value for preview
                />
            ))}
        </div>
    );
};

export default RecognitionsPreview;